import { motion } from "framer-motion";
import { CheckCircle } from "@phosphor-icons/react";
import { t } from "../i18n";
import { fadeUp, stagger, viewport } from "../motion";

export default function WhyChoose() {
  const w = t.de.why;
  // bento spans for asymmetry (lg:12 cols)
  const spans = [
    "lg:col-span-5", "lg:col-span-4", "lg:col-span-3",
    "lg:col-span-3", "lg:col-span-4", "lg:col-span-5",
    "lg:col-span-7", "lg:col-span-5",
  ];
  return (
    <section data-testid="why" className="relative py-24 md:py-36 bg-navy-900 text-white overflow-hidden grain">
      <div className="absolute top-1/3 -left-40 w-[30rem] h-[30rem] bg-gold-500/10 rounded-full blur-3xl" />
      <div className="container mx-auto px-6 md:px-12 max-w-7xl relative">
        <motion.div variants={stagger} initial="hidden" whileInView="show" viewport={viewport} className="max-w-2xl mb-16">
          <motion.div variants={fadeUp} className="flex items-center gap-3 mb-6">
            <span className="h-px w-10 bg-gold-500" />
            <span className="text-xs font-semibold uppercase tracking-[0.25em] text-gold-400">{w.overline}</span>
          </motion.div>
          <motion.h2 variants={fadeUp} className="text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight leading-tight">
            {w.title}
          </motion.h2>
        </motion.div>

        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.1 }}
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-5"
        >
          {w.items.map((item, i) => (
            <motion.div
              key={item}
              variants={fadeUp}
              data-testid={`why-item-${i}`}
              className={`${spans[i]} group flex items-center gap-4 p-6 md:p-7 rounded-2xl backdrop-blur-xl bg-white/[0.04] border border-white/10 transition-all duration-500 hover:bg-white/[0.08] hover:border-gold-500/40`}
            >
              <CheckCircle size={30} weight="light" className="text-gold-400 shrink-0 transition-transform group-hover:scale-110" />
              <span className="text-lg md:text-xl font-outfit font-light leading-snug break-words min-w-0">{item}</span>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
